import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import ChaptersIndex from './pages/ChaptersIndex';
import Chapter from './pages/Chapter';
import Conference from './pages/Conference';
import News from './pages/News';
import Contact from './pages/Contact';
import VoterRegistration from './pages/VoterRegistration';
import Admin from './pages/Admin';
import DigitalJournal from './pages/DigitalJournal';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/chapters" element={<ChaptersIndex />} />
            <Route path="/chapters/:slug" element={<Chapter />} />
            <Route path="/conference" element={<Conference />} />
            <Route path="/news" element={<News />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/voter-registration" element={<VoterRegistration />} />
            <Route path="/digital-journal" element={<DigitalJournal />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </Layout>
        <Toaster position="top-right" theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;
